<template>
  <el-dropdown @command="handleCommand">
    <el-button type="primary" :size="size"  :disabled="ids.length < 1">
      <slot></slot><i class="el-icon-arrow-down el-icon--right"></i>
    </el-button>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-if="json.type == 'hkqr'" command="remark">批量备注</el-dropdown-item>
      <el-dropdown-item v-if="json.type == 'hkqr'" command="duizhang">批量对账</el-dropdown-item>
      <el-dropdown-item v-if="json.type == 'hkqr'" command="batchBack">批量退回</el-dropdown-item>
      <el-dropdown-item v-if="json.type == 'qtsf'" command="sendToKd">批量发送金蝶</el-dropdown-item>
      <el-dropdown-item v-if="json.type == 'qtsf'" command="sendbackdee">批量撤回金蝶</el-dropdown-item>
      <el-dropdown-item v-if="json.type == 'qtsf'" command="cancelDJ">批量作废单据</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>
<script>
export default {
  name:"LyBatchOperation",
  props: {
    json: {
      type: Object,
      default: () => {}
    }, // 备注提交的地址
    rows: { // 要备注列的数据集合
      type: Array,
      default: () => []
    },            
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
      ids () {
          let id = []
          this.rows.forEach((el) => {
              if (el.id) {
                  id.push(el.id)
              }
          })
          return id
      }
  },
  methods: {
    handleCommand (command) {
      switch (command) {
        case "remark":
          this.remarkOpen();
          break;
        case "duizhang":
          this.duizhang();
          break;
        case "batchBack":
          this.batchBack();
          break;
        case "sendToKd":
          this.sendKingdee();
          break;
        case "sendbackdee":
          this.sendbackdee();
          break;
        case "cancelDJ":
          this.cancelDJ();
          break;
      }
    },
    cancelDJ () {
      this.$confirm('是否要批量作废单据？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            callback: action => {
                if (action === 'confirm') {
                    this.$api.create(this.json.cancelDJApi, {
                        ids: this.ids
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '批量作废单据完成'
                        })
                        this.$emit('operDone')
                    }).catch((msg) => {
                        this.$message({
                            type: 'warning',
                            message: msg
                        })
                    })
                }
            }
        })
    },
    /**
     * 撤回金蝶
     */
    sendbackdee () {
        this.$confirm('是否要批量撤回金蝶？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            callback: action => {
                if (action === 'confirm') { 
                    this.$api.save(this.json.backJindieApi, {
                        ids: this.ids,
                        type: "backjindie"
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '批量撤回金蝶完成'
                        })
                        this.$emit('operDone')
                    }).catch((msg) => {
                        this.$message({
                            type: 'warning',
                            message: msg
                        })
                    })
                }
            }
        })
    },
    /**
     * 发送到金蝶
     */
    sendKingdee () {
        this.$confirm('是否要批量发送金蝶？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            callback: action => {
                if (action === 'confirm') {
                    this.$api.save(this.json.sendJindieApi, {
                        ids: this.ids
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '批量发送金蝶完成'
                        })
                        this.$emit('operDone')
                    }).catch((msg) => {
                        this.$message({
                            type: 'warning',
                            message: msg
                        })
                    })
                }
            }
        })
    },
    batchBack () {
      this.$confirm('确定对已勾选的单据删除金蝶单据并退回？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            callback: action => {
                if (action === 'confirm') {   
                    this.$api.create(this.json.batchBackApi, {
                        ids: this.ids
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '批量退回完成'
                        })
                        this.$emit('operDone')
                    }).catch((msg) => {
                        this.$message({
                            type: 'warning',
                            message: msg
                        })
                    })
                }
            }
        })
    },
    duizhang () {
      this.$confirm('确定对已勾选的单据进行批量对账？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            callback: action => {
                if (action === 'confirm') {
                    this.$api.create(this.json.duizhangApi, {
                        ids: this.ids
                    }).then(() => {
                        this.$message({
                            type: 'success',
                            message: '批量对账完成'
                        })
                        this.$emit('operDone')
                    }).catch((msg) => {
                        this.$message({
                            type: 'warning',
                            message: msg
                        })
                    })
                }
            }
        })
    },
    remarkOpen () {
        this.$prompt('请输入备注', '批量备注', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: "暂不处理",
            inputPattern: /^.{2,1000}$/,
            inputErrorMessage: '请输入备注内容'
        }).then(({value}) => {
            this.submitRemark(value)
        })
        console.log('this.$el:%O', this.$el)
    },
    /**
     * 提交备注
     */
    submitRemark (remark) {
        this.$api.create(this.json.remarkApi, {
            ids: this.ids,
            remark: remark
        }).then(() => {
            this.$message({
                type: 'success',
                message: '批量备注完成'
            })
        }).catch((msg) => {
            this.$message({
                type: 'warning',
                message: msg
            })
        })
    }
  }
}
</script>